import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import Accordion from "@/components/Accordion"
import AccordionItem from "@/components/AccordionItem"
import Longform from "@/components/Longform"
import MediaWrapper from "@/components/MediaWrapper"
import { getFaqAnswerText } from "@/utils/faq-structured-data"

import { useTranslation } from "@zestia/gatsby-plugin-react-i18next"

const FAQ = ({ data, title = "common.faq", className = "" }) => {
  const { t } = useTranslation()

  return (
    <section className={`container-fluid row ${className}`}>
      <div className="col-xs-12 col-sm-4 first-sm">
        <h3 className="mb-10">{t(title)}</h3>
      </div>

      <Accordion
        className="col-xs-12 col-sm-offset-1 col-sm-7 mb-10 sm:mb-0"
        fillContainer="true"
        faq
      >
        {data.map(item => (
          <AccordionItem
            key={item.title}
            title={item.title}
            schemaAnswer={getFaqAnswerText(item)}
          >
            {typeof item.description === "string" ? (
              <p>{item.description}</p>
            ) : (
              item.description
            )}
            {item.list && (
              <Longform>
                <ol>
                  {item.list.map(listItem => (
                    <li key={listItem}> {listItem} </li>
                  ))}
                </ol>
              </Longform>
            )}
            {item.image && (
              <MediaWrapper background="true">
                <GatsbyImage
                  image={getImage(item.image.src)}
                  alt={item.image.alt}
                />
              </MediaWrapper>
            )}
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  )
}

export default FAQ
